import { useEffect } from 'react';
import { useUpdate } from '@bydesign-ui/hooks';
import { useSelect } from './useSelect';
export function useOptionUpdate() {
  var select = useSelect();
  var update = useUpdate();
  useEffect(function () {
    select.addListener('select-option-update', update);
    return function () {
      select.removeListener('select-option-update', update);
    };
  }, []);
}